import { Checkbox, CheckboxChangeEvent, TextArea } from '@progress/kendo-react-inputs';

/** Max characters allowed in a note body. */
export const NOTE_MAX_LENGTH = 2000;

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  /** When set, shows the "Internal only" checkbox on the counter row (internal users only). */
  showInternalToggle?: boolean;
  internalOnly?: boolean;
  onInternalOnlyChange?: (value: boolean) => void;
}

/**
 * Note body textarea with a hard character cap (`NOTE_MAX_LENGTH`) + a live counter. Optionally
 * renders the "Internal only" toggle on the counter row. Shared by the add-note form and the
 * inline edit cards so both enforce/show the same limit and toggle.
 */
export default function NoteDescriptionInput({
  value,
  onChange,
  placeholder,
  rows = 4,
  showInternalToggle = false,
  internalOnly = false,
  onInternalOnlyChange,
}: Props) {
  const atLimit = value.length >= NOTE_MAX_LENGTH;
  return (
    <div>
      <TextArea
        value={value}
        onChange={(e) => onChange((e.value as string) ?? '')}
        placeholder={placeholder}
        rows={rows}
        maxLength={NOTE_MAX_LENGTH}
        style={{ width: '100%' }}
      />
      <div className="mt-0.5 flex items-center justify-between gap-2">
        {/* TODO: only show for internal (GreaseBoss) users once the backend user flag exists. */}
        {showInternalToggle ? (
          <Checkbox
            label="Internal only"
            value={internalOnly}
            onChange={(e: CheckboxChangeEvent) => onInternalOnlyChange?.(e.value)}
          />
        ) : (
          <span />
        )}
        <span className={`text-xs ${atLimit ? 'text-red-500' : 'text-gray-400'}`}>
          {value.length}/{NOTE_MAX_LENGTH}
        </span>
      </div>
    </div>
  );
}
